import React, { useContext, useEffect, useState } from 'react';
import { Store } from '../Store';
import { addToOrder, removeFromOrder} from '../actions';
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  Tabs,
  Tab
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import GradingIcon from '@mui/icons-material/Grading';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AccountCircleIcon from '@material-ui/icons/AccountCircle'; 
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RemoveIcon from '@material-ui/icons/Remove';
import { useStyles } from '../styles';
import Logo from '../components/Logo';
import { useHistory } from "react-router-dom"; 
import CurrencySymbol  from '../components/CurrencySymbol';
import { setPaymentType, generateQrCode, getCheckoutUrl } from '../actions';
// import Slider from "react-slick";
import config,{ getParameterByName,merchantCode} from '../util';
export default function Cart(props) {
  const styles = useStyles();
  const { state, dispatch } = useContext(Store);
  const {
    orderItems,
    itemsCount,
    totalPrice,
    taxPrice,
    orderType,
  } = state.order;
  let {setting} = state.userSetting;
    console.log(setting);
   const selectedCurrency = state.selectedCurrency;
  console.log(selectedCurrency);
  const history = useHistory();
  
  // const isPaymentAllowed = getParameterByName("isPaymentAllowed");
  let isPaymentAllowed = setting?setting.isPaymentAllowed:"";
  console.log(isPaymentAllowed);
  const [quantity, setQuantity] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [product, setProduct] = useState({});
  const [addons,setAddons]=useState([]);
  const [openSign,setOpenSign] =useState(false);
  const [tabSel, setTabSel] = React.useState(1);
    let {userInfo}=state.userData;
        let userData =localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):null;
  const getCurrency = userInfo? userInfo.currency:"";
  const getPercent = setting? setting.taxPercent:"";
  let items = [];
  if (orderItems && orderItems.length) {
    orderItems.map((o) => {
      items.push({
        price_data: {
          currency: getCurrency,
          product_data: {
            name: o.name
          },
          unit_amount: o.price * 100 + (o.price * getPercent / 100) * 100
        },
        quantity: o.quantity
      })
    });
  }
    const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }
  const goto =(subpath) =>{
      history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }
  const closeHandler = () => {
    setIsOpen(false);
  };
  const productClickHandler = (p) => {
    console.log(orderItems);
    let existingOrder = orderItems && orderItems.filter(o => o._id == p._id);
    setProduct(p);
    setAddons(JSON.parse(p.sub_pro));
    if (existingOrder.length) {
      setQuantity(existingOrder[0].quantity);
    } else {
      setQuantity(1);
    }
    setIsOpen(true);
  };

  const addToOrderHandler = () => {
    addToOrder(dispatch, { ...product, quantity });
    setIsOpen(false);
  };

  const cancelOrRemoveFromOrder = () => {
    removeFromOrder(dispatch, product);
    setIsOpen(false);
  };

  const procedToCheckoutHandler = () => {
     
    props.history.push('/payment?' + window.location.href.split('?')[1]);
    
  };


  //  if(setting){
  //    setTimeout(() => {
  //     let textcolor = document.getElementById("title1");
  //     textcolor.style.color = setting.color_primary;
  //   }, 10);
    
  // }

  const adAddons = (adId)=>{
    console.log(product,adId);
    let existingItem= product;
    let adOns = JSON.parse(existingItem.sub_pro).map((ad)=>{
                                                            if(ad._id === adId){
                                                                ad.quantity=ad.quantity+1;
                                                            }
                                                            return ad;
                                                     })
        console.log(adOns);
        setAddons(adOns);
        existingItem.sub_pro=JSON.stringify(adOns);
        setProduct(existingItem);

  }

 const removeAddons = (adId)=>{
  console.log(product,adId);
  let existingItem= product;
  let adOns = JSON.parse(existingItem.sub_pro).map((ad)=>{
                                                          if(ad._id===adId){
                                                              ad.quantity=ad.quantity-1;
                                                          }
                                                          return ad;
                                                   })
      console.log(adOns);
      setAddons(adOns);
        existingItem.sub_pro=JSON.stringify(adOns);
        setProduct(existingItem);

 }


  return (
    <Box className={[styles.root]} style={{backgroundColor: userData.themeTxtColor}}>
      <Box className={[styles.main, styles.center]} style={{justifyContent:"start"}}>
       
        <Box className={[styles.center, styles.around]} style={{backgroundColor: userData.themeTxtColor,width:"100%"}}>
          <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 1 }}>
        <ArrowBackIosNewIcon 
          style={{color: userData.themeColor}} 
          onClick={() => history.goBack()}
        />
        <Typography variant="h4" style={{ color:userData.themeColor, fontFamily: userData.themeSecondaryFontFam }}>
          Your Cart
        </Typography>
        <Box style={{width: "24px"}} /> {/* Spacer for alignment */}
      </Box>
   
      
      
        </Box>
        <Box  style={{overflowY:"auto",height:'500px', width:"100%"}}>
        <Grid container >
          {orderItems && orderItems.map((orderItem) =>{
            console.log(orderItem);
            if(typeof orderItem.sub_pro != 'object'){
            orderItem.sub_pro=  JSON.parse(orderItem.sub_pro);
            }
            let adons = orderItem.sub_pro.addons;
            let varts = orderItem.sub_pro.variety;
            let cis =  orderItem.sub_pro.cookInstructions;
            let adNames='';
            return(
            <Grid item md={12} sm={12} xs={12} key={orderItem.name}>
              <Card
                className={[styles.card, styles.editCard]}
               
                style={{border:"1px solid "+ userData.themeColor, marginTop:"5px"}}
              >
                
                <CardActionArea  >
                  <CardContent>
                    <Box className={[styles.row, styles.between,styles.itemsCenter]}>
                    <img
  src={orderItem.image}
  alt={orderItem.name}
  style={{
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "5px",

  }}
  onError={(e) => { e.target.src = "/images/blank.png" }}
/>
                      <div>
                        <Typography
                          gutterBottom
                          variant="h6"
                          className={styles.reviwText}
                          component="p"
                        >
                        
                     <b>{orderItem.name}</b> <br />   <i style={{fontSize:"0.7em",background:"#f781e9", padding:"0px 2px", margin:"2px 5px", borderRadius:"5px"}}>{Object.keys(varts).length? Object.keys(varts)[0]:"" }</i><i style={{fontSize:"0.7em",background:"#81f7ef", padding:"0px 2px", margin:"2px 5px", borderRadius:"5px"}}>  {adons.length? adons.map(ad=> adNames+ad.name+',') : ""} </i> <br /> <i style={{fontSize:"0.7em",background:"#f7eb81", padding:"2px", margin:"2px 5px", borderRadius:"5px"}}>{cis.length ? cis[0] : ""}</i>

                        </Typography>
                        <div className='amount'>
                        <span>{orderItem.quantity} x <CurrencySymbol/>{orderItem.price + (adons.reduce((acc, val) => acc + val.price, 0) : 0)}</span>
                          
                      </div>
                      </div>
                      
                     <Box
  style={{
    display: "flex",
    flexDirection: "column",  
    alignItems: "center",
    marginLeft: "10px",
     fontFamily: userData.themeSecondaryFontFam
  }}
>
  
<Button
    onClick={(e) => {
      e.stopPropagation();
      setProduct(orderItem);
      setQuantity(orderItem.quantity + 1);
      addToOrder(dispatch, { ...orderItem, quantity: orderItem.quantity + 1 });
    }}
    style={{
      backgroundColor: userData.themeColor,
      color: userData.themeTxtColor,
      minWidth: "40px",
       fontFamily: userData.themeSecondaryFontFam,
      height: "40px",
      borderRadius: "50%",
    }}
  >
    <KeyboardArrowUpIcon/>
  </Button>
  <Typography
    style={{
      width: "28px",
      textAlign: "center",
      fontSize: "16px",
       fontFamily: userData.themeSecondaryFontFam,
      margin: "8px",
      fontWeight:"bold"
    }}
  >
    {orderItem.quantity}
  </Typography>
<Button
    onClick={(e) => {
      e.stopPropagation();
      setProduct(orderItem);
      setQuantity(orderItem.quantity - 1);
      if(orderItem.quantity==1){
        removeFromOrder(dispatch,orderItem);
      }else{
      addToOrder(dispatch, { ...orderItem, quantity: orderItem.quantity - 1 });
      }
    }}
   
    style={{
      backgroundColor: userData.themeColor,
      color: userData.themeTxtColor,
      minWidth: "40px",
      height: "40px",
      borderRadius: "50%",
      fontFamily: userData.themeSecondaryFontFam,
      marginBottom: "8px"
    }}
  >
   <KeyboardArrowDownIcon/>
  </Button>
  
</Box>
                    </Box>
                  
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          )})}
        </Grid>
        </Box>
      </Box>
      <Box >
        <Box style={{marginBottom: '150px',
    textAlign: 'center',padding:"10px"}}>
          <Box className={[styles.bordered, styles.between, styles.space]}style={{ textAlign: 'center', fontSize: '18px', lineHeight: "20px",width:"100%" ,margin:"0px",display:"block"    }}>
             Tax:
            <CurrencySymbol/>{taxPrice} | Total: <CurrencySymbol/>{totalPrice}
          </Box>
             <Button
              onClick={procedToCheckoutHandler}
              variant="contained"
              disabled={!orderItems.length}
              className={styles.largeButton}
              id="review_nxbtn"
              style={{marginTop:"10px", background:userData.themeColor, color:userData.themeTxtColor}}
            >
               Checkout
            </Button>
        </Box>
      </Box>

       <Tabs 
        style={{
          backgroundColor: userData.themeTxtColor,
          borderTop: "2px solid " + userData.themeColor,
          padding:"10px"
        }} 
        className="footer-tab" 
        value={tabSel} 
        onChange={handleTabChange} 
        aria-label="tabs footer"
      >
        <Tab 
          style={{
            background: tabSel==0 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==0 ? '#fff' : ""
          }} 
          onClick={() => goto('order')} 
          icon={<HomeIcon />}  
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==1 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==1 ? '#fff' : "",
            position: 'relative',
          }} 
          onClick={() => goto('cart')} 
          icon={
            <Box sx={{ position: 'relative', padding: '4px' }}>
              <ShoppingCartIcon />
             
               {state.order.itemsCount > 0 && (
                          <span className={"badge"} style={{background:'red',color:'#fff'}}>
                            {state.order.itemsCount}
                          </span>
                        )}
             
            </Box>
          }
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==2 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==2 ? '#fff' : ""
          }} 
          onClick={() => {
            setTabSel(2);
            goto('favourites');
          }} 
          icon={<FavoriteIcon />} 
          label="" 
        />
        <Tab
          style={{
            background: tabSel==3 ? userData.themeColor : "",
            borderRadius: "24px",
            color: tabSel==3 ? '#fff' : "",
            position: 'relative'
          }}
          onClick={() => {
            history.push('/profile?' + window.location.href.split("?")[1]);
          }}
          icon={<AccountCircleIcon />}
          label="" 
        />
      </Tabs>
    </Box>
  );
}
